import { CircularProgress } from '@material-ui/core';
import { FrontendLayout_MainContent_ID } from 'app/Layout/FrontendLayout';
import Infinite, {
  Props as InfiniteProps,
} from 'react-infinite-scroll-component';

export interface InfiniteScrollProps
  extends Pick<
    InfiniteProps,
    | 'children'
    | 'next'
    | 'hasMore'
    | 'dataLength'
    | 'className'
    | 'style'
    | 'hasChildren'
    | 'scrollableTarget'
    | 'scrollThreshold'
  > {}

export const InfiniteScroll = ({
  children,
  style,
  className,
  scrollableTarget = FrontendLayout_MainContent_ID,
  ...props
}: InfiniteScrollProps) => {
  return (
    <Infinite
      loader={
        <h4 style={{ display: 'flex', justifyContent: 'center' }}>
          <CircularProgress size={30} />
        </h4>
      }
      className={className}
      scrollableTarget={scrollableTarget}
      style={
        style ??
        (className !== undefined
          ? undefined
          : {
              overflow: 'hidden',
              display: 'flex',
              flexDirection: 'column',
              gap: 16,
            })
      }
      {...props}
    >
      {children}
    </Infinite>
  );
};
